import type { Appointment, ZoomSettings } from 'src/models/appointment/_types';
import type {
  ZoomSettings as ScheduledZoomSettings,
  ZoomMeeting,
} from 'src/models/scheduled-appointment/_types';

interface ZoomSource {
  zoomMeeting?: ZoomMeeting | Appointment['zoomMeeting'] | null;
  zoom?: ZoomSettings | ScheduledZoomSettings | null;
  isScheduledAppointment: boolean;
}

/**
 * Resolves the correct source for zoom data, matching v2's `zoomModel` computed property.
 *
 * v2 logic (modal-new-appointment.js lines 128-135):
 *   If scheduledAppointment.id exists AND the service does NOT have uniqueZoomLink,
 *   zoom data lives on the scheduledAppointment. Otherwise it lives on the appointment.
 */
export function getZoomSource(appointment: Appointment): ZoomSource {
  const hasScheduledAppointment = !!appointment.scheduledAppointmentId;
  const uniqueZoomLink = !!appointment.service?.uniqueZoomLink;

  if (hasScheduledAppointment && !uniqueZoomLink && appointment.scheduledAppointment) {
    return {
      zoomMeeting: appointment.scheduledAppointment.zoomMeeting ?? null,
      zoom: appointment.scheduledAppointment.zoom ?? null,
      isScheduledAppointment: true,
    };
  }

  return {
    zoomMeeting: appointment.zoomMeeting ?? null,
    zoom: appointment.zoom ?? null,
    isScheduledAppointment: false,
  };
}
